(function () {
  function initFloatingLabel(container) {
    // Skip if already initialized
    if (container.dataset.floatingInitialized) return;
    container.dataset.floatingInitialized = 'true';

    const input = container.querySelector('input, textarea');
    if (!input) return;

    // Initial floating state if there's already a value (e.g. autofill)
    if (input.value.trim() !== '') {
      container.classList.add('is-floating');
    }

    input.addEventListener('focus', () => {
      container.classList.add('has-focus', 'is-floating');
    });

    input.addEventListener('blur', (e) => {
      container.classList.remove('has-focus');
      if (e.target.value.trim() === '') {
        container.classList.remove('is-floating');
      }
    });
  }

  // Initialize all current floating-label containers
  function initAllFloatingLabels() {
    document.querySelectorAll('.floating-label').forEach(initFloatingLabel);
  }

  // Observe DOM for newly added floating-label elements
  function observeFloatingLabels() {
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        mutation.addedNodes.forEach((node) => {
          if (!(node instanceof HTMLElement)) return;

          if (node.classList?.contains('floating-label')) {
            initFloatingLabel(node);
          } else {
            node.querySelectorAll?.('.floating-label').forEach(initFloatingLabel);
          }
        });
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  // Run when DOM is ready
  window.addEventListener('DOMContentLoaded', () => {
    initAllFloatingLabels();
    observeFloatingLabels();
  });
})();

/**
 * Trap focus within a given container (e.g., dialog, alert, modal).
 * 
 * @param {HTMLElement} container - The container element that should trap focus.
 */
function trapFocus(container) {
  if (!container) return;

  const focusableSelectors = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled]):not([type="hidden"])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])'
  ].join(',');

  // Select all potential focusable elements
  const allFocusable = Array.from(container.querySelectorAll(focusableSelectors));

  // Filter only visible elements
  const focusableElements = allFocusable.filter(el => {
    const style = window.getComputedStyle(el);
    const rect = el.getBoundingClientRect();
    return (
      style.display !== 'none' &&
      style.visibility !== 'hidden' &&
      style.opacity !== '0' &&
      rect.width > 0 &&
      rect.height > 0
    );
  });

  if (!focusableElements.length) return;

  const firstFocusable = focusableElements[0];
  const lastFocusable = focusableElements[focusableElements.length - 1];

  // Ensure container itself is focusable
  if (!container.hasAttribute('tabindex')) {
    container.setAttribute('tabindex', '-1');
  }

  container.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;

    const activeEl = document.activeElement;

    // Shift + Tab on first → loop to last
    if (e.shiftKey && activeEl === firstFocusable) {
      e.preventDefault();
      lastFocusable.focus();
    }
    // Tab on last → loop to first
    else if (!e.shiftKey && activeEl === lastFocusable) {
      e.preventDefault();
      firstFocusable.focus();
    }
  });
}

// On domContentLoaded, initialize focus traps for elements with data-trap-focus
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[role="alert"]').forEach(trapFocus);
  document.querySelectorAll('[role="dialog"]:not(.quickshop__product--modal)').forEach(trapFocus);
});

// Fix for Recharge Subscribe accessibility
(function () {
  let product_recharge = setInterval(translateRecharge, 1000);
  function translateRecharge() {
    let subscription_widget = $(".recharge-subscribe");
    if (subscription_widget != null && subscription_widget.length > 0) {
      clearInterval(product_recharge);
      subscription_widget.find(".text-block > .head-title").html(window.variantStrings.subscriptionTitle);
      subscription_widget.find(".text-block > .cancel-anytime").html(window.variantStrings.subscriptionSubTitle);
      // No longer need to set role/aria-checked since we're using a real checkbox input
    }
  }
})();

// Custom Radio
(function () {
  document.querySelectorAll('[role="radiogroup"]').forEach((group) => {
    const radios = group.querySelectorAll('[role="radio"]');

    radios.forEach((radio, index) => {
      radio.addEventListener("click", () => {
        selectRadio(index);
      });

      radio.addEventListener("keydown", (e) => {
        if (e.key === " " || e.key === "Enter") {
          e.preventDefault();
          selectRadio(index);
        } else if (e.key === "ArrowRight" || e.key === "ArrowDown") {
          e.preventDefault();
          selectRadio((index + 1) % radios.length);
        } else if (e.key === "ArrowLeft" || e.key === "ArrowUp") {
          e.preventDefault();
          selectRadio((index - 1 + radios.length) % radios.length);
        }
      });
    });

    function selectRadio(selectedIndex) {
      radios.forEach((r, i) => {
        const isSelected = i === selectedIndex;
        r.setAttribute("aria-checked", isSelected);
        r.tabIndex = isSelected ? 0 : -1;
        r.classList.toggle("selected", isSelected);
        if (isSelected) {
          // Click
          r.click();
          // Focus
          r.focus();
        }
      });
    }
  });

})();

// Convert first paragraph in .collection_long_description to h2
document.addEventListener('DOMContentLoaded', () => {
  const container = document.querySelector('.collection_long_description');
  if (!container) return;

  const firstElement = container.firstElementChild;
  if (!firstElement) return;

  // Check if the first element is a paragraph and not already a heading
  const isParagraph = firstElement.tagName.toLowerCase() === 'p';
  const isHeading = /^h[1-6]$/i.test(firstElement.tagName);

  if (isParagraph && !isHeading) {
    const h2 = document.createElement('h2');
    h2.innerHTML = firstElement.innerHTML;
    firstElement.replaceWith(h2);
  }
});

// Tabs Accessibility
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll('[role="tablist"]').forEach(tabList => {
    const tabs = [...tabList.querySelectorAll('[role="tab"]')].filter(tab => (
      tab.closest('[role="tablist"]') === tabList
      && (tab.dataset.tabId || tab.querySelector('[data-tab-id]'))
    ));
    if (!tabs.length) return;

    const getTargetId = tab => tab.dataset.tabId || tab.querySelector('[data-tab-id]')?.dataset.tabId;
    const panels = tabs.map(tab => document.querySelector(
      `[role="tabpanel"][id="${CSS.escape(getTargetId(tab))}"]`,
    ));

    const selectTab = selectedTab => {
      tabs.forEach((tab, index) => {
        const selected = tab === selectedTab;
        tab.classList.toggle('is-active', selected);
        tab.setAttribute('aria-selected', selected ? 'true' : 'false');
        tab.setAttribute('tabindex', selected ? '0' : '-1');
        panels[index]?.classList.toggle('is-active', selected);
        if (panels[index]) panels[index].hidden = !selected;
      });
    };

    const initialTab = tabs.find(tab => tab.classList.contains('is-active')) || tabs[0];
    selectTab(initialTab);

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => selectTab(tab));
      tab.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        let nextIndex = index;
        if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = tabs.length - 1;
        event.preventDefault();
        selectTab(tabs[nextIndex]);
        tabs[nextIndex].focus();
      });
    });
  });
});

// Cart drawer accessibility
document.addEventListener("DOMContentLoaded", () => {
  const cartDrawer = document.querySelector('#cart');
  if (!cartDrawer) return;

  // Allow the drawer to be focusable
  if (!cartDrawer.hasAttribute('tabindex')) {
    cartDrawer.setAttribute('tabindex', '-1');
  }

  // Stop global TAB handlers (Shopify themes use one)
  cartDrawer.addEventListener("keydown", (e) => {
    if (e.key === "Tab") e.stopPropagation();
  });

  cartDrawer.addEventListener("keydown", (e) => {
    if (e.key !== "Tab") return;

    const focusableSelectors = [
      'a[href]',
      'button:not([disabled])',
      'input:not([disabled]):not([type="hidden"])',
      'select:not([disabled])',
      'textarea:not([disabled])',
      '[tabindex]:not([tabindex="-1"])'
    ].join(',');

    // Get focusable elements inside the cart drawer
    const all = Array.from(cartDrawer.querySelectorAll(focusableSelectors));

    // Only keep visible elements
    const focusable = all.filter(el => {
      const rect = el.getBoundingClientRect();
      const style = getComputedStyle(el);
      return (
        style.display !== 'none' &&
        style.visibility !== 'hidden' &&
        rect.width > 0 &&
        rect.height > 0
      );
    });

    if (focusable.length === 0) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    const active = document.activeElement;

    // SHIFT + TAB → First to last
    if (e.shiftKey && active === first) {
      e.preventDefault();
      last.focus();
    }

    // TAB → Last to first
    if (!e.shiftKey && active === last) {
      e.preventDefault();
      first.focus();
    }
  });

  // Close button click handler
  let closeButton = cartDrawer.querySelector('.mm-subclose');
  if (closeButton) {
    closeButton.addEventListener('click', () => {
      console.log("close")
      let focusReturn = document.querySelector('[data-return-focus="true"]');
      if (focusReturn) {
        focusReturn.focus();
        focusReturn.removeAttribute('data-return-focus');
      }
    });
  }
});

// Restore removed elements in cart items
document.addEventListener("DOMContentLoaded", () => {
  const cartItems = document.querySelectorAll(".cart_item");
  if (!cartItems.length) return;

  cartItems.forEach((item) => {
    // Save the original children of THIS item
    const original = item.cloneNode(true);

    const observer = new MutationObserver((mutations) => {
      for (let m of mutations) {
        if (m.removedNodes.length > 0) {
          // Restore original inner HTML for this item only
          item.innerHTML = original.innerHTML;

          observer.disconnect(); // Run only once
          break;
        }
      }
    });

    observer.observe(item, { childList: true });
  });
});

// Move <header> right below <body> for better screen reader support
document.addEventListener("DOMContentLoaded", () => {
  setTimeout(() => {
    const headerSection = document.querySelector("#shopify-section-header");
    const header = document.querySelector("header");

    if (headerSection && header) {
      headerSection.appendChild(header);
      document.body.insertAdjacentElement("afterbegin", headerSection);
    }

    // Move .skip-to-content-link above the header
    const skipLink = document.querySelector(".skip-to-content-link");
    if (skipLink) {
      document.body.insertAdjacentElement("afterbegin", skipLink);
    }

  }, 300);

  setTimeout(() => {
    const footer = document.querySelector(".footer-section");
    document.querySelector("#main-content").insertAdjacentElement("afterend", footer);
    document.body.classList.add("page-loaded");

  }, 1000);
});

// // replace ais-Pagination-list <div> with <nav> for better accessibility
// document.addEventListener("DOMContentLoaded", () => {
//   const observer = new MutationObserver(() => {
//     const paginationList = document.querySelector(".ais-Pagination");
//     if (!paginationList) return;

//     const nav = document.createElement("nav");
//     nav.className = paginationList.className;
//     nav.innerHTML = paginationList.innerHTML;

//     paginationList.replaceWith(nav);
//     observer.disconnect(); // stop watching once done
//   });

//   observer.observe(document.body, { childList: true, subtree: true });

// });




// Observer for Recharge "How Subscriptions Work" popup
(function() {
  const fixHowItWorks = () => {
    const popups = document.querySelectorAll('.rc_popup__how_it_works');
    popups.forEach(popup => {
      const strong = popup.querySelector('strong');
      if (strong) {
        const h3 = document.createElement('h3');
        h3.innerHTML = strong.innerHTML;
        strong.replaceWith(h3);
        popup.classList.add('observed');
      }
    });
  };

  // Run on any change
  const observer = new MutationObserver(fixHowItWorks);
  observer.observe(document.documentElement, { 
    childList: true, 
    subtree: true,
    attributes: true 
  });

  // Also poll every second in case elements are added via methods that don't trigger common mutations 
  // or exist in Shadow DOM if relevant (though querySelectorAll won't see Shadow DOM, this helps with timing)
  setInterval(fixHowItWorks, 1000);

  // Run immediately
  if (document.readyState === 'loading') {
    window.addEventListener('load', fixHowItWorks);
  } else {
    fixHowItWorks();
  }
})();

// Language and currency selector hover/click logic
document.addEventListener("DOMContentLoaded", () => {
  const selectors = [
    { trigger: '.js-select-language', menu: '#language_nav-menu' },
    { trigger: '.js-select-currency', menu: '#currency_nav-menu' }
  ];

  selectors.forEach(({ trigger: tSelector, menu: mSelector }) => {
    const triggers = document.querySelectorAll(tSelector);
    const menu = document.querySelector(mSelector);
    if (!triggers.length || !menu) return;

    triggers.forEach(trigger => {
      // Fix/Add click listener for language (currency click is handled in theme.liquid)
      if (tSelector === '.js-select-language') {
        trigger.addEventListener('click', (e) => {
          e.preventDefault();
          const isOpen = menu.style.display === 'block';
          menu.style.display = isOpen ? 'none' : 'block';
          trigger.setAttribute('aria-expanded', !isOpen);
        });
      }

      // Add hover logic for both
      const parent = trigger.closest('.header-currency');
      if (parent) {
        parent.addEventListener('mouseenter', () => {
          trigger.setAttribute('aria-expanded', 'true');
        });
        parent.addEventListener('mouseleave', () => {
          const isClickedOpen = menu.style.display === 'block';
          trigger.setAttribute('aria-expanded', isClickedOpen ? 'true' : 'false');
        });
      }
    });
  });
});
